<template>
  <div class="reservation-steps text-left pl-6 pl-md-1">
    <v-row>
      <v-col cols="12" md="10" offset-md="1">
        <div class="mb-4 mb-md-6 mt-2 mt-md-6 reservation-steps-header">
          {{$t('reservation.reservation')}}
        </div>
        <div class="d-flex align-center">
          <a :class="['reservation-step d-flex align-center px-2', $vuetify.display.mobile ? 'mobile' : '', canIGoToMyPhenotypeStep() ? 'clickable' : '']" @click="goToMyPhenotypeStep()">
            <span :class="['step-no', $route.name === 'reservationPhenotypeView' && $route.params.type === 'own' 
              ? 'current' : '']">1</span>
            <span :class="['label pl-2', $route.name === 'reservationPhenotypeView' && $route.params.type === 'own' 
              ? 'current' : '']">
              {{$t('recipient.add_phenotype_step_label')}}
            </span>
          </a>

          <v-icon v-if="!$vuetify.display.mobile" class="icon" icon="mdi-chevron-right" color="primary"></v-icon>

          <a :class="['reservation-step d-flex align-center px-2', $vuetify.display.mobile ? 'mobile' : '', canIGoToMyPartnerPhenotypeStep() ? 'clickable' : '']" @click="goToMyPartnerPhenotypeStep()">
            <span :class="['step-no', $route.name === 'reservationPhenotypeView' && $route.params.type === 'partner' 
              ? 'current' : '']">2</span>
            <span :class="['label pl-2', $route.name === 'reservationPhenotypeView' && $route.params.type === 'partner' 
              ? 'current' : '']">
              {{$t('recipient.add_partner_phenotype_step_label')}}
            </span>
          </a>

          <v-icon v-if="!$vuetify.display.mobile" class="icon" icon="mdi-chevron-right" color="primary"></v-icon>

          <a :class="['reservation-step d-flex align-center px-2', $vuetify.display.mobile ? 'mobile' : '', canIGoToConfirmationStep() ? 'clickable' : '']" @click="goToConfirmationStep()"
            >
            <span :class="['step-no', $route.name === 'confirmationView' ? 'current' : '']">3</span>
            <span :class="['label pl-2', $route.name === 'confirmationView' ? 'current' : '']">
              {{$t('confirmation.step_label')}}
            </span>
          </a>

          <v-icon v-if="!$vuetify.display.mobile" class="icon" icon="mdi-chevron-right" color="primary"></v-icon>

          <a :class="['reservation-step d-flex align-center px-2', $vuetify.display.mobile ? 'mobile' : '']">
            <span :class="['step-no', $route.name === 'reservationView' ? 'current' : '']">4</span>
            <span :class="['label pl-2', $route.name === 'reservationView' ? 'current' : '']">
              {{$t('reservation.data_step_label')}}
            </span>
          </a>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { useRouter, useRoute } from 'vue-router'

export default {
  setup() {
    const router = useRouter()
    const route = useRoute()
    const canIGoToMyPhenotypeStep = () => ['reservationView','confirmationView','reservationPhenotypeView'].includes(route.name) ? true : false
    const canIGoToMyPartnerPhenotypeStep = () => ['reservationView','confirmationView','reservationPhenotypeView'].includes(route.name) && route.params.type !== 'own' ? true : false
    const canIGoToConfirmationStep = () => ['reservationView'].includes(route.name) ? true : false

    const goToMyPhenotypeStep = () => {
      if (canIGoToMyPhenotypeStep()) {
        router.push({name: 'reservationPhenotypeView', params: { type: 'own'}})
        window.scrollTo({ top: 0, behavior: 'smooth'})
      }
    }
    const goToMyPartnerPhenotypeStep = () => {
      if (canIGoToMyPartnerPhenotypeStep()) {
        router.push({name: 'reservationPhenotypeView', params: { type: 'partner'}})
        window.scrollTo({ top: 0, behavior: 'smooth'})
      }
    }
    const goToConfirmationStep = () => {
      if (canIGoToConfirmationStep()) {
        router.push({name: 'confirmationView'})
        window.scrollTo({ top: 0, behavior: 'smooth'})
      }
    }

    return {
      canIGoToMyPhenotypeStep,
      goToMyPhenotypeStep,
      canIGoToMyPartnerPhenotypeStep,
      goToMyPartnerPhenotypeStep,
      canIGoToConfirmationStep,
      goToConfirmationStep,
    }
  }
}
</script>

<style lang="scss" scoped>
  .reservation-steps {
    background: unset;
    .reservation-steps-header {
      @include nsb-font-header;
      font-size: 16px;
      line-height: 26px;
    }
    .reservation-step {
      &.clickable{
        cursor: pointer;
      }
      &.mobile {
        .label {
          display: none;
          &.current {
            display: inline;
          }
        }
        .step-no.current {
          width: 32px;
          height: 32px;
        }
      }
      &:first-of-type {
        padding-left: 0px !important;
      }
      .step-no {
        display: flex;
        width: 24px;
        height: 24px;
        padding: 8px;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        @include nsb-font-label;
        font-size: 14px;
        line-height: 22px;
        color: $ds-white;
        background: $ds-primary-200;
        border-radius: 100px;
        &.current {
          background: $ds-primary;
        }
      }
    }
  }

  @media (min-width: 960px) {
    .reservation-steps { 
      z-index: 11;
      margin: 0 auto;
      width: 1200px;
    }
  }
</style>